"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListingPurposeType = exports.SfilterType = void 0;
var SfilterType;
(function (SfilterType) {
    SfilterType[SfilterType["BUY"] = 0] = "BUY";
    SfilterType[SfilterType["RENT"] = 1] = "RENT";
    SfilterType[SfilterType["BUYRENT"] = 2] = "BUYRENT";
    SfilterType[SfilterType["ALL"] = 3] = "ALL";
})(SfilterType = exports.SfilterType || (exports.SfilterType = {}));
var ListingPurposeType;
(function (ListingPurposeType) {
    ListingPurposeType[ListingPurposeType["Sale"] = 1] = "Sale";
    ListingPurposeType[ListingPurposeType["Rent"] = 2] = "Rent";
    ListingPurposeType[ListingPurposeType["Both"] = 3] = "Both";
    ListingPurposeType[ListingPurposeType["All"] = 4] = "All";
})(ListingPurposeType = exports.ListingPurposeType || (exports.ListingPurposeType = {}));
(function (SfilterType) {
    SfilterType.toListingPurposeType = function (sfilterType) {
        switch (sfilterType) {
            case SfilterType.BUY: return ListingPurposeType.Sale;
            case SfilterType.RENT: return ListingPurposeType.Rent;
            case SfilterType.BUYRENT: return ListingPurposeType.Both;
            case SfilterType.ALL: return ListingPurposeType.All;
        }
    };
    SfilterType.toString = function (sfilterType) {
        switch (sfilterType) {
            case SfilterType.BUY: return 'buy';
            case SfilterType.RENT: return 'rent';
            case SfilterType.BUYRENT: return 'buyrent';
        }
        return '';
    };
    SfilterType.toStringWithDefault = function (sfilterType) {
        var sfilterStr = SfilterType.toString(sfilterType);
        return !sfilterStr ? 'buy' : sfilterStr;
    };
})(SfilterType = exports.SfilterType || (exports.SfilterType = {}));
(function (ListingPurposeType) {
    ListingPurposeType.toSfilterType = function (type) {
        switch (type) {
            case ListingPurposeType.Sale: return SfilterType.BUY;
            case ListingPurposeType.Rent: return SfilterType.RENT;
            case ListingPurposeType.Both: return SfilterType.BUYRENT;
        }
        return SfilterType.ALL;
    };
    ListingPurposeType.toString = function (type) {
        switch (type) {
            case ListingPurposeType.Sale: return 'buy';
            case ListingPurposeType.Rent: return 'rent';
        }
        return '';
    };
})(ListingPurposeType = exports.ListingPurposeType || (exports.ListingPurposeType = {}));
